import { useEffect } from 'react';
import { Box, Stack, Typography, Link } from '@mui/material';
import { FormProvider } from 'react-hook-form';
import { ResetPasswordFormFields } from '../components';
import { ForgotPasswordButton } from '../components/Button';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useResetPasswordMutation, useResetPasswordForm } from '../hooks';
import { toast } from 'react-toastify';

export const ResetPassword = () => {
  const form = useResetPasswordForm();
  const navigate = useNavigate();
  const resetPasswordMutation = useResetPasswordMutation();
  const [searchParams] = useSearchParams();

  // ✅ Submit handler that only submits the latest values
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const token = searchParams.get('token');
    if (!token) {
      toast.error('Token is missing from the URL');
      return;
    }

    form.setValue('token', token); // ensure latest token
    const isValid = await form.trigger();

    if (!isValid) return;

    const formData = form.getValues(); // get latest form values
    resetPasswordMutation.mutate(formData);
  };

  return (
    <FormProvider {...form}>
      <Stack
        component="form"
        width={'330px'}
        spacing={2}
        sx={{ mt: 9 }}
        onSubmit={handleSubmit}
      >
        <Typography
          variant="h5"
          fontWeight={700}
          align="center"
          gutterBottom
          sx={{ color: '#33408e' }}
        >
          Change your password
        </Typography>
        <Typography
          variant="body1"
          align="center"
          mb={3}
          sx={{ color: '#4c4c4c' }}
        >
          Enter a new password below to <br /> change your password
        </Typography>

        <ResetPasswordFormFields />

        <Box display="flex" justifyContent="center">
          <ForgotPasswordButton type="submit" disabled={resetPasswordMutation.isPending}>
            {resetPasswordMutation.isPending ? 'Saving...' : 'Save New Password'}
          </ForgotPasswordButton>
        </Box>

        <Box mt={3} mb={3} textAlign="center">
          <Link
            underline="hover"
            fontSize={13}
            sx={{ color: '#4c4c4c !important' }}
            onClick={() => navigate('/')}
          >
            Back to Login
          </Link>
        </Box>
      </Stack>
    </FormProvider>
  );
};